import React, {useState} from 'react'
import {Col} from 'jsxstyle'
import {useNavigate} from 'react-router-dom'
import {XpertKnowledgeTutorialStatus} from '../../../services/XpertKnowledgeTutorial/type'
import ActivityLogsDialog from '../../../components/ActivityLogsDialog'
import i18n from '../../../common/i18n'
import XpertKnowledgeActivityLogs from './RightBar/XpertKnowledgeActivityLogs'
import XpertKnowledgeQualityIndicator from './RightBar/XpertKnowledgeQualityIndicator'
import {useXpertKnowledgeContext} from '../../XpertKnowledge/XpertKnowledgeContext'
import {useXpertKnowledgeTutorialContext} from '../XpertKnowledgeTutorialContext'
import XpertKnowledgeActions from './RightBar/XpertKnowledgeActions'

const XpertKnowledgeTutorialRightBar: React.FC = () => {
  const {selectedXpertKnowledgeTutorial, submitXpertKnowledgeTutorial} = useXpertKnowledgeTutorialContext()
  const {selectedXpertKnowledge} = useXpertKnowledgeContext()
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false)

  if (!selectedXpertKnowledge || !selectedXpertKnowledgeTutorial) {
    return <></>
  }

  return (
    <>
      <Col width="48%" margin="14px 24px 14px 14px" gap="20px" overflowY="scroll">
        <XpertKnowledgeActions />
        <XpertKnowledgeActivityLogs xpertKnowledgeTutorial={selectedXpertKnowledgeTutorial} onSubmit={() => setIsConfirmDialogOpen(true)} />
        {selectedXpertKnowledgeTutorial.status !== XpertKnowledgeTutorialStatus.PUBLISHED && selectedXpertKnowledge.overallQualityScore && (
          <XpertKnowledgeQualityIndicator xpertKnowledgeQualityScore={selectedXpertKnowledge.overallQualityScore} />
        )}
      </Col>
      <ActivityLogsDialog
        title={i18n.t('xk.tutorial.edit.dialogs.approvalRequest.title')}
        subtitle={i18n.t('xk.tutorial.edit.dialogs.approvalRequest.subtitle')}
        sendLabel={i18n.t('xk.tutorial.edit.dialogs.approvalRequest.sendLabel')}
        onSend={async (value: string) => {
          await submitXpertKnowledgeTutorial({
            comment: value || '',
          })
          setIsConfirmDialogOpen(false)
        }}
        placeholder={i18n.t('xk.tutorial.edit.dialogs.approvalRequest.placeholder')}
        onCancel={() => setIsConfirmDialogOpen(false)}
        open={isConfirmDialogOpen}
        setOpen={setIsConfirmDialogOpen}
      />
    </>
  )
}

export default XpertKnowledgeTutorialRightBar
